module.exports = __webpack_public_path__ + "static/img/min-crystal.639567a1.png";